import { useIsEnabled } from '@portal/shared/hooks/useIsEnabled';
import { useSetAtomV53NotificationShown } from '@portal/state/atoms/v53NotificationShown';
import { useV53AccountIdentifier } from '@portal/state/hooks/useV53AccountIdentifier';
import { useNotificationState } from '@portal/state/internal/notificationState';
import { useEffect } from 'react';
import { Feature } from '../utils/featureToggle';

export function useShowV53Notification() {
  const setV53ShownAtom = useSetAtomV53NotificationShown();
  const isV53FeatureEnabled = useIsEnabled(Feature.V53);
  const isV53Account = useV53AccountIdentifier();
  const isEnabled = isV53FeatureEnabled && isV53Account;

  const notification = useNotificationState('V53_DISMISSED');

  useEffect(() => {
    if (!isEnabled || !notification.isOpen || notification.isLoading) {
      return;
    }

    setV53ShownAtom(true);
  }, [notification.isOpen, isEnabled, setV53ShownAtom, notification.isLoading]);

  return {
    // Only show if enabled, not loading, and notification should be open
    isOpen: isEnabled && !notification.isLoading && notification.isOpen,
    handleClose: notification.handleClose,
    isLoading: notification.isLoading
  };
}
